import { render, staticRenderFns } from "./NewSolutionDetails.vue?vue&type=template&id=5cbdb27e&scoped=true&"
import script from "./NewSolutionDetails.vue?vue&type=script&lang=js&"
export * from "./NewSolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewSolutionDetails.vue?vue&type=style&index=0&id=5cbdb27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbdb27e",
  null
  
)

export default component.exports